
let datePickerinstance = null
let advancedDatePickerinstance = null

export const getDatePicker = async () =>  {
    if (!datePickerinstance) {
        datePickerinstance = await import(/*webpackChunkName: 'date-picker'*/"./DatePicker")
    }

    return datePickerinstance
}
export const getAdvancedDatePicker = async () =>  {
    if (!advancedDatePickerinstance) {
        advancedDatePickerinstance = await import(/*webpackChunkName: 'advanced-date-picker'*/"./AdvancedDatePicker")
    }

    return advancedDatePickerinstance
}